import React from 'react';
import Tittle from './Tittle';
import Typewriter from 'typewriter-effect';


const Myblogs = () => {
    return (
        <div>
            <div className="b-title">
                <Tittle title={'My Blogs'} span={'My Blogs'} />
            </div>
            <h1><Typewriter
                options={{
                    strings: ['Comming Soon My Blogs'],
                    autoStart: true,
                    loop: true,
                }}
            /></h1>
        </div>
    );
};

export default Myblogs;